import type { PopupConfig } from '@coorum-research/shared-common/types/popup.type'

export function canDisplayPopup() {
  return window.parent.window.innerWidth >= 450
}

export function setLauncherDisplayMode(element: HTMLElement) {
  const isPopup = canDisplayPopup()
  const displayMode = isPopup ? 'popup' : 'sheet'

  element.dataset.displayMode = displayMode

  return displayMode
}

export function setResearchRootPositionAndHeight(element: HTMLElement, config: PopupConfig | undefined | null) {
  const launcherHorizontalPosition = Number(config?.horizontal ?? 12)
  const launcherVerticalPosition = Number(config?.vertical ?? 12)
  const displayPosition = config?.displayPosition ?? 'bottom-left'

  // ポップアップとランチャー間のギャップを考慮したポジションを設定
  if (displayPosition === 'bottom-left') {
    element.style.left = `${launcherHorizontalPosition}px`
    element.style.bottom = `${launcherVerticalPosition}px`
  } else if (displayPosition === 'bottom-right') {
    element.style.right = `${launcherHorizontalPosition}px`
    element.style.bottom = `${launcherVerticalPosition}px`
  }

  // ランチャーのHeightを設定
  element.style.height = `calc(100% - ${launcherVerticalPosition}px)`
}

const containerOpenClass = 'cr-research-container-open'
const containerCloseClass = 'cr-research-container-close'

export function setPopupAnimationClass(element: HTMLElement, mode: 'open' | 'close') {
  switch (mode) {
  case 'open':
    element.classList.remove(containerCloseClass)
    element.classList.add(containerOpenClass)
    break
  case 'close':
    element.classList.remove(containerOpenClass)
    element.classList.add(containerCloseClass)
    break
  }
}
